/**
 * Shareable links that open the landing page with the prompt prefilled:
 *
 *   https://www.molecule.dev/#prompt=An%20AI%20travel%20agent...
 *   https://www.molecule.dev/?prompt=...
 *
 * The hash form is preferred (nothing reaches the server or analytics), the
 * query form is accepted for tools that cannot set a fragment.
 */

/**
 * The prompt a page location carries, or `''`.
 *
 * @param hash - `location.hash`, with or without the leading `#`.
 * @param search - `location.search`, with or without the leading `?`.
 * @returns The trimmed prompt text; the hash wins when both are set.
 */
export function promptFromLocation(hash: string, search = ''): string {
  const fromHash = new URLSearchParams(hash.replace(/^#/, '')).get('prompt')
  const fromQuery = new URLSearchParams(search.replace(/^\?/, '')).get('prompt')
  return (fromHash ?? fromQuery ?? '').trim()
}

/**
 * A link to the landing page with a prompt prefilled and selected.
 *
 * @param prompt - The prompt text.
 * @param origin - The site origin, default the public site.
 * @returns The URL.
 */
export function promptLink(prompt: string, origin = 'https://www.molecule.dev'): string {
  return `${origin}/#prompt=${encodeURIComponent(prompt.trim())}`
}
